<template>
  <div class="shadow-num-card">
    <y-icon :icon="icon" :color="iconColor"></y-icon>
    <div class="flex-column">
      <div class="shadow-num-card-title">
        {{ title }}
      </div>
      <div class="shadow-num-card-value">
        {{ displayValue }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShadowNumCard",
  props: {
    icon: {
      type: String,
      default: ""
    },
    iconColor: {
      type: String,
      default: "#1890ff"
    },
    title: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    duration: {
      type: Number,
      default: 2000 // 动画持续时间，单位毫秒
    }
  },
  data() {
    return {
      displayValue: 0, // 用于动画显示的数值
      animationFrame: null // 存储动画帧ID，用于取消动画
    };
  },
  watch: {
    value: {
      immediate: true, // 立即执行一次
      handler(newVal) {
        const num = parseFloat(newVal);
        if (!isNaN(num)) {
          this.animateNumber(num);
        }
      }
    }
  },
  methods: {
    animateNumber(target) {
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }

      const start = parseFloat(this.displayValue) || 0;
      const duration = this.duration;
      const startTime = performance.now();
      const endTime = startTime + duration;

      const animate = (currentTime) => {
        const progress = Math.min((currentTime - startTime) / duration, 1);
        // 使用Math.round四舍五入到整数
        this.displayValue = Math.round(start + (target - start) * progress);

        if (currentTime < endTime) {
          this.animationFrame = requestAnimationFrame(animate);
        } else {
          this.displayValue = target; // 确保最终值准确
        }
      };

      this.animationFrame = requestAnimationFrame(animate);
    },
    formatNumber(value) {
      // 如果需要格式化数字（如添加千分位分隔符），可以在这里处理
      return value.toFixed(0); // 这里简单处理为整数
    }
  },
  computed: {
    formattedValue() {
      return this.formatNumber(this.displayValue);
    }
  },
  beforeDestroy() {
    // 组件销毁前取消动画
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';

.shadow-num-card {
  border-radius: 4px;
  box-shadow: 0 0 6px 2px #eff0f5;
  padding: 0 20px;
  background: #ffffff;
  margin: 8px;
  display: flex;
  align-items: center;
  flex: 1;
  gap: 20px;
  min-width: 200px; // 添加最小宽度防止内容过小时变形

  .shadow-num-card-title {
    color: #5E6776;
    font-size: @font-size-sm;
    font-weight: bold;
    letter-spacing: 2px;
    white-space: nowrap; // 防止标题换行
  }

  .shadow-num-card-value {
    font-weight: bold;
    color: #222222;
    font-size: @font-size-xlg;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/ShadowNumCard.vue